export default {
    labels: {
        headerTitle: 'Detalhes da cobrança',
        chargesTitle: 'Documentos do item de cobrança',
        pendingSupportFiles: 'Documento do item de cobrança ausente',
        receivedSupportFiles: 'Documentos do item de cobrança anexados',
        observations: 'Observações',
    },
}